import { createNativeStackNavigator } from "@react-navigation/native-stack";
import ChangeBoardScreen from "../screens/changeboardscreen";
import { pageTitle } from "../context/helper";
import BoardInfoScreen from "../screens/boardinfoscreen";
import FirmSelectStack from "../screens/firmselectscreen";

const Stack = createNativeStackNavigator();

const ServiceStack = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        component={BoardInfoScreen}
        name="BoardInfo"
        options={{ title: pageTitle("Sensorboxinfo") }}
      />
      <Stack.Screen
        component={ChangeBoardScreen}
        name="BoardScreen"
        options={{ title: pageTitle("Einstellungen Sensorbox") }}
      />
      <Stack.Screen
        component={FirmSelectStack}
        name="FirmScreen"
        options={{ title: pageTitle("Firma wählen") }}
      />
    </Stack.Navigator>
  );
};

export default ServiceStack;
